import Progress from 'react-progress-2';
import API from '../api/wp';

/**
 * Constant
 */

export const FETCH_BLOG = 'blog/FETCH_BLOG';
export const FETCH_BLOG_OK = 'blog/FETCH_BLOG_OK';
export const FETCH_BLOG_FAILED = 'blog/FETCH_BLOG_FAILED';


/**
 * Action
 */

export function getBlog(params = null) {
    return async (dispatch) => {
        dispatch({ type: FETCH_BLOG });
        Progress.show();

        try {
            const blog = await API.getBlog(params);
            dispatch({ type: FETCH_BLOG_OK, blog: blog.data });
            Progress.hide();
        } catch (err) {
            dispatch({ type: FETCH_BLOG_FAILED });
            Progress.hide();
        }
    }
}


/**
 * Reducer
 */

const initialState = {
    isLoading: false,
    blog: [],
};

export default function blog(state = initialState, action) {
    switch (action.type) {
        case FETCH_BLOG:
            return {
                ...state,
                isLoading: true,
            };
        
        case FETCH_BLOG_OK:
            return {
                ...state,
                isLoading: false,
                blog: action.blog,
            };
        
        case FETCH_BLOG_FAILED:
            return {
                ...state,
                isLoading: false,
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/blog.js